const inputGroup = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.input-group').forEach((target: HTMLElement) => {
      this.handleInputGroup(target)
    })
  },

  handleInputGroup(target): void {
    const el = {
      inputGroup: target,
      input: target.querySelector(`input:not([type='checkbox'], [type='radio'])`) || target.querySelector('textarea'),
      select: target.querySelector('select'),
    }

    const method = {
      init(): void {
        if (el.input) {
          method.hasValue(el.input)
          el.input.addEventListener('change', () => {
            method.hasValue(el.input)
          })
          el.input.addEventListener('keyup', () => {
            method.hasValue(el.input)
          })
        }

        if (el.select) {
          method.hasValue(el.select)
          el.select.addEventListener('change', () => {
            method.hasValue(el.select)

            const isAnchor = (el.select as HTMLSelectElement).dataset.anchor

            if (isAnchor === 'true') {
              window.location.href = (el.select as HTMLSelectElement).value
            }
          })
        }
      },

      hasValue(target): void {
        if (target.value.length > 0 && target.value !== 'placeholder') {
          el.inputGroup.classList.add('input-group--filled')
        } else {
          el.inputGroup.classList.remove('input-group--filled')
        }
      },
    }

    method.init()
  },
}

export default inputGroup
